export const permissaoAtribuicao = ['1', '2', '3', '4', '6'];
export const permissaoTodosCarimbos = ['1', '2'];
//export const permissaoAtribuicao = ['1', '2', '3', '4', '5', '6', '7'];
//export const permissaoAtribuicao = ['1', '2', '3', '4', '5', '6', '7'];
//export const permissaoAtribuicao = ['1', '2', '3', '4', '5', '6', '7'];
//export const permissaoAtribuicao = ['1', '2', '3', '4', '5', '6', '7'];